export const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

/**
 * Mirrors the backend's `createTagBody`/`updateTagBody` limits (tags.schemas.ts).
 * Shared by `TagsPage.tsx` and `TagPicker.tsx`, which both create/edit a tag with
 * the same `name`/`color` shape.
 */
export function validateTag(name: string, color: string): Record<string, string> {
  const errors: Record<string, string> = {};
  const trimmed = name.trim();
  if (trimmed.length < 1) {
    errors.name = 'Enter a tag name.';
  } else if (trimmed.length > 60) {
    errors.name = 'Name must be 60 characters or fewer.';
  }
  if (!HEX_COLOR_RE.test(color)) {
    errors.color = 'Colour must be a hex value like #3366ff.';
  }
  return errors;
}
